import React from 'react';
import './posts.scss';

const HumanEdEGM = () => {
  return (
    <div className="evaluation-container">
      <h1>Elected Technical Director of the HumanEd Computer Vision Team</h1>
      <h3>Category: Student Activity</h3>
      <p className="date">Written at home on Saturday, 24 March 2025.</p>
      <img
        src="https://firebasestorage.googleapis.com/v0/b/portfolio-bfe5b.appspot.com/o/humaned_egm.png?alt=media&token=afdbdaab-6f16-48d8-b3b5-f45b34e80a64"
        alt="humaned_egm"
        className="cafe-image"
      />
      <p>
        During the annual general meeting (AGM) of our Humanoid Robotics Society, three positions remained unfilled: Treasurer, Technical Director of the Computer Vision Team, and Technical Director of the Robotic Arms Team.
      </p>
      <p>
        As a result, we held an Emergency General Meeting (EGM) to vote on candidates for these roles. I was particularly interested in the Technical Director position for the Computer Vision Team, so I submitted my manifesto and applied.
      </p>

      <img
        src="https://firebasestorage.googleapis.com/v0/b/portfolio-bfe5b.appspot.com/o/manifesto.png?alt=media&token=455b64f4-2d7a-4784-b189-462417539afc"
        alt="manifesto"
        className="cafe-image"
      />
      <p>
        The election turned out to be highly competitive—almost a fifty-fifty split—which I honestly didn’t expect. Fortunately, I won by a margin of four votes.
      </p>
      <p>
        As the new Technical Director of the Computer Vision Team, I’ll be responsible for overseeing the applicant selection process for the Computer Vision Advanced Teams and managing the team’s projects throughout the next academic year.
      </p>
      <p>
        I’m truly excited to take on this role and can’t wait to dive into new projects and collaborations after the summer!
      </p>
      

    </div>
  );
};

export default HumanEdEGM;